import { useState, useEffect } from "react";
import { defaultTheme } from "react-select"
import reportStore from "../../../../stores/report-store";
import { TableRow, TableCell } from '@material-ui/core';


const JumperTransactionAnalysis = ({ date, onFetchjumperTansactionAnalysisData }) => {

    const [data, setData] = useState([]);

    useEffect(() => {
        fetchData();
    }, [date]);

    const fetchData = async () => {
        try {
            const res = await reportStore.GetJumperTransactionAnalysis(formatDate(date));

            const safeData = Array.isArray(res)
                ? res
                : Array.isArray(res?.data)
                    ? res.data
                    : [];

            setData(safeData);
            onFetchjumperTansactionAnalysisData(safeData);
        } catch (error) {
            console.error("Error fetching data:", error);
            setData([]);
            onFetchjumperTansactionAnalysisData([]);
        }
    };

    const formatDate = (date = new Date()) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    const renderData = (val = {}) => {
        const headings = [
            'jumperName',
            'startingBalance',
            'todayBalance',
            'todayPaid',
            'endDayBalance'
        ];

        const amountFields = [
            'startingBalance',
            'todayBalance',
            'todayPaid',
            'endDayBalance'
        ];

        return headings.map((key) => {
            let cellValue = val?.[key];

            if (cellValue === undefined || cellValue === null) {
                cellValue = key === 'jumperName' ? '-' : 0;
            }

            // Apply toFixed(2) only for amount fields
            if (amountFields.includes(key)) {
                cellValue = Number(cellValue).toFixed(2);
            }

            return (
                <TableCell key={key} style={{ padding: '0.5rem 0 0 2.8rem' }}>
                    {cellValue}
                </TableCell>
            );
        });
    };

    const renderRow = () => {
        if (!Array.isArray(data) || data.length === 0) {
            return (
                <TableRow>
                    <TableCell colSpan={5} align="center">
                        No Data Found
                    </TableCell>
                </TableRow>
            );
        }

        return data.map((v, i) => (
            <TableRow key={i}>
                {renderData(v)}
            </TableRow>
        ));
    };

    return (
        <>
            {renderRow()}
        </>
    )
}

export default JumperTransactionAnalysis;